import { RealEstateAgent } from '../../utility/types';
import { api } from '../configs/axiosConfigs';

type GetPropertyAgentsResponse = {
  data: {
    success: boolean;
    listing_agent: RealEstateAgent | null;
    buying_agent: RealEstateAgent | null;
  };
};

export const getPropertyAgents = async (
  propertyId: string
): Promise<GetPropertyAgentsResponse> => {
  return await api.get(`/properties/${propertyId}/property-agents`);
};
